import { categoryPortals, fermentList, hotSearchWords, siteStats } from "@/mocks/gossipData";

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-accent-200/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 h-80 w-80 rounded-full bg-primary-200/40 blur-3xl"></div>
      </div>

      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 pb-12 pt-10 md:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:pb-16 lg:pt-14">
        <div className="rise-in">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <span className="flame-pulse inline-flex items-center"><i className="ri-fire-fill text-accent-500"></i></span>
            同学口碑 · 防踩雷资源站
          </div>
          <h2 className="mt-5 font-heading text-3xl font-black leading-[1.2] tracking-tight text-foreground-950 md:text-[2.6rem]">
            别等被坑了才认识人，
            <br />
            校园社交圈的<span className="relative whitespace-nowrap text-primary-600">
              里子
              <span className="absolute inset-x-0 -bottom-1 h-2 rounded bg-accent-300/60"></span>
            </span>
            先替你摸清
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
            从校园风云人物争议、同学圈避雷名单，到学生干部评优与社团经费疑点——把散落在群聊、表白墙和公示栏里的蛛丝马迹，整理成一份能直接参考的口碑底账。换届前、组队前、借钱前，先看一眼。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#heat"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 hover:bg-primary-600"
            >
              <i className="ri-fire-fill"></i>
              看今日热议榜
            </a>
            <a
              href="#avoid"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-bold text-foreground-800 hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-shield-check-line text-accent-600"></i>
              查避雷名单
            </a>
          </div>

          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {siteStats.map((s) => (
              <div key={s.label} className="rounded-lg border border-background-200 bg-background-50/80 px-3 py-2.5">
                <div className="font-heading text-xl font-extrabold text-foreground-950">{s.value}</div>
                <div className="mt-0.5 text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="rise-in rise-in-delay-2">
          <div className="rounded-xl border border-accent-200 bg-accent-50/70 p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text-sm font-bold text-accent-900">
                <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-accent-950">
                  <i className="ri-flashlight-fill text-xs"></i>
                </span>
                正在发酵
              </div>
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-900">
                <i className="ri-radar-line"></i> 实时跟踪
              </span>
            </div>
            <div className="mt-4 flex flex-col gap-2.5">
              {fermentList.map((f) => (
                <a
                  key={f.name}
                  href="#heat"
                  className="group flex items-center justify-between gap-2 rounded-lg bg-background-50/90 px-3.5 py-2.5 transition hover:bg-background-100"
                >
                  <span className="truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">{f.name}</span>
                  <span className="flex shrink-0 items-center gap-2">
                    <span className={`text-xs font-bold ${f.trend === "down" ? "text-secondary-600" : "text-primary-600"}`}>
                      {f.delta}
                    </span>
                    <span className="text-[11px] text-foreground-400">{f.heat}</span>
                  </span>
                </a>
              ))}
            </div>
            <div className="mt-4 flex items-center justify-between border-t border-accent-200/70 pt-3 text-[11px] text-foreground-500">
              <span>热度按近 24h 讨论增量估算</span>
              <a href="#heat" className="inline-flex items-center gap-1 font-semibold text-primary-600 hover:text-primary-700">
                全部榜单 <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function PortalGrid() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-primary-700">板块总览 · 直接入口</span>
            <h2 className="mt-2 font-heading text-2xl font-extrabold text-foreground-950">六大分区，一条线索都不错过</h2>
          </div>
          <p className="max-w-sm text-xs leading-relaxed text-foreground-500">
            每一条都标注来源与核实状态，按题材分区归档，点进去即可纵向深挖。
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoryPortals.map((c) => (
            <a
              key={c.key}
              href={`#${c.key === "people" ? "people" : c.key === "avoid" ? "avoid" : c.key === "cadre" ? "cadre" : c.key === "club" ? "club" : c.key === "flip" ? "flip" : "topic"}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition hover:-translate-y-0.5 hover:border-primary-300 hover:bg-primary-50/50"
            >
              <div className="flex items-start justify-between">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span className="inline-flex items-center gap-1 rounded-md bg-background-100 px-2 py-1 text-[11px] font-semibold text-foreground-600">
                  {c.count} 条
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-extrabold text-foreground-950 group-hover:text-primary-700">{c.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.blurb}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-400">{c.tag}</span>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-600 opacity-0 transition group-hover:opacity-100">
                  进入分区 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export { hotSearchWords };